import { render, staticRenderFns } from "./instructores.vue?vue&type=template&id=0c35c294&scoped=true&"
import script from "./instructores.vue?vue&type=script&lang=js&"
export * from "./instructores.vue?vue&type=script&lang=js&"
import style0 from "./instructores.vue?vue&type=style&index=0&id=0c35c294&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c35c294",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMain: require('/builds/marketing/abstracta.academy-website/components/HeaderMain.vue').default})
